var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import CryptoES from 'crypto-es';
import { AccessTokenMissingException } from '../model/access-token-missing.exception';
import { AuthenticatedApiService } from './authenticated-api.service';
import { AuthenticationService } from '../services/authentication.service';
import { CreditCardsApiService } from './credit-cards-api.service';
import { VehicleBuilder } from '../builders/vehicle-builder';
import { AdminShiftBuilder } from '../builders/adminShift-builder';
import { AgentBuilder } from '../builders/agent-builder';
import { ReservationBuilder } from '../builders/reservation-builder';
import { UserBuilder } from '../builders/user-builder';
import { PaymentMethodBuilder } from '../builders/payment-method-builder';
import { ProductBuilder } from '../builders/product-builder';
import { ProfileBuilder } from '../builders/profile-builder';
import { ApiService } from './api.service';
import { AdminProfileBuilder } from '../builders/admin-profile-builder';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "./authenticated-api.service";
import * as i3 from "../services/authentication.service";
import * as i4 from "./credit-cards-api.service";
export class AgentApiService {
    constructor(apiService, authenticatedApi, unauthenticatedApi, auth, creditCardsApiService) {
        this.apiService = apiService;
        this.authenticatedApi = authenticatedApi;
        this.unauthenticatedApi = unauthenticatedApi;
        this.auth = auth;
        this.creditCardsApiService = creditCardsApiService;
    }
    createReservation(reservation) {
        const payload = ReservationBuilder.buildReservationPayload(reservation);
        return this.authenticatedApi
            .post('/adminreservations', JSON.stringify(payload))
            .toPromise()
            .then(response => ReservationBuilder.buildReservation(response.reservation));
    }
    listAgents() {
        return this.authenticatedApi
            .get("/adminproduct/agents")
            .toPromise()
            .then((response) => {
            return response.agents.map(data => AgentBuilder.buildAgent(data));
        });
    }
    getAgent() {
        return this.authenticatedApi
            .get("/agent")
            .toPromise()
            .then((response) => {
            return AgentBuilder.buildAgent(response.agent);
        });
    }
    updateAgent(agent, position) {
        const agentPayload = {
            app_lot: agent.appLot,
            id_last_lot: agent.currentLot,
            email: agent.email,
            name: agent.name,
            alias: agent.alias,
            phone: agent.phone,
            push_platform: agent.pushPlatform,
            push_token: agent.pushToken,
            shuttle_push_token: agent.shuttlePushToken,
            surname: agent.lastName
        };
        let payload;
        if (position) {
            payload = {
                agent: agentPayload,
                position: position
            };
        }
        else {
            const positionPayload = {
                lat: agent.premium.position.lat,
                lng: agent.premium.position.lng,
            };
            payload = {
                agent: agentPayload,
                position: positionPayload
            };
        }
        return this.authenticatedApi
            .put("/agent", JSON.stringify(payload))
            .toPromise()
            .then((response) => AgentBuilder.buildAgent(response.agent));
    }
    updateAgentLocation(position) {
        let payload;
        payload = {
            position: position
        };
        return this.authenticatedApi
            .put("/agent", JSON.stringify(payload))
            .toPromise()
            .then((response) => AgentBuilder.buildAgent(response.agent));
    }
    setAgentLot(idLot) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.put('/agent', { agent: { id_last_lot: idLot } }).toPromise();
            return AgentBuilder.buildAgent(response.agent);
        });
    }
    setAgentPaydesk(idPaydesk) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.put('/agent', { agent: { current_id_paydesk: idPaydesk } }).toPromise();
            return AgentBuilder.buildAgent(response.agent);
        });
    }
    requestNewPassword(email) {
        return this.apiService
            .get("/agent/password", { email })
            .toPromise()
            .then((response) => response);
    }
    changePassword(currentPassword, newPassword) {
        const payload = {
            current: currentPassword,
            new: newPassword
        };
        return this.authenticatedApi
            .post("/agent/password", JSON.stringify(payload))
            .toPromise()
            .then((response) => response);
    }
    updateAgentReady() {
        return this.authenticatedApi
            .post("/agent/ready")
            .toPromise()
            .then((response) => response);
    }
    updateAgentOut() {
        return this.authenticatedApi
            .post("/agent/out")
            .toPromise()
            .then((response) => response);
    }
    enableMultiReception(idProduct, idTerminal) {
        return this.authenticatedApi
            .post(`/agent/multireception/${idProduct}/${idTerminal}`)
            .toPromise()
            .then((response) => response);
    }
    disableMultiReception() {
        return this.authenticatedApi
            .delete(`/agent/multireception`)
            .toPromise()
            .then((response) => response);
    }
    updateAgentPhoto_v0(imageUpload) {
        return this.authenticatedApi
            .multipart("/agent/photo", imageUpload.bodyForUpload)
            .toPromise()
            .then((response) => response);
    }
    updateAgentPhoto(formData) {
        return this.authenticatedApi
            .multipart("/agent/photov2", formData)
            .toPromise()
            .then((response) => response);
    }
    deleteAgentPhoto() {
        return this.authenticatedApi
            .delete("/agent/photo")
            .toPromise()
            .then((response) => response);
    }
    listNextUnassignedServices(lotId, page = 0, type = "premium") {
        return this.listNextServices(lotId, page, "unassigned", type);
    }
    listNextAllServices(lotId, page = 0, type = "premium") {
        return this.listNextServices(lotId, page, null, type);
    }
    listCompletedServices(lotId, page = 0, type = "premium") {
        const payload = { type, page };
        return this.authenticatedApi
            .get(`/adminservice/history/${lotId}`, payload)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicesList(response));
    }
    searchService(lotId, query, page = 0, type = "premium") {
        const payload = { type, page, query };
        return this.authenticatedApi
            .get(`/adminservice/search/${lotId}`, payload)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicesList(response));
    }
    updateAgentService(reservationId, agentService) {
        const payload = AgentBuilder.buildAgentServicePayload(agentService);
        return this.authenticatedApi
            .put(`/adminservice/${reservationId}`, JSON.stringify(payload))
            .toPromise()
            .then((response) => ReservationBuilder.buildReservation(response.reservation));
    }
    updatePremiumClientPrediction(reservationId, duration) {
        return this.authenticatedApi
            .post(`/adminservice/clientPrediction/${reservationId}/${duration}`)
            .toPromise()
            .then((response) => response);
    }
    uploadServicePhoto(reservationId, formData) {
        let uploadPhotoUrl = `/adminservice/imagev2/${reservationId}`;
        return this.authenticatedApi
            .multipart(uploadPhotoUrl, formData)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicePhoto(response.image));
    }
    uploadSignatureImageToErase(reservationId, formData) {
        let uploadPhotoUrl = `/adminservice/imagev2/${reservationId}?signature=true`;
        return this.authenticatedApi
            .multipart(uploadPhotoUrl, formData)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicePhoto(response.image));
    }
    updateServicePhoto(reservationId, imageUpload, isSignature) {
        let uploadPhotoUrl = `/adminservice/image/${reservationId}`;
        if (isSignature) {
            uploadPhotoUrl = `${uploadPhotoUrl}?signature=true`;
        }
        let options = {};
        options.headers = {};
        options.headers['Content-Type'] = 'multipart/form-data boundary=---BOUNDARY';
        return this.authenticatedApi
            .multipart(uploadPhotoUrl, imageUpload.bodyForUpload, options)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicePhoto(response.image));
    }
    uploadSignatureImage(reservationId, imageUpload) {
        let uploadPhotoUrl = `/adminservice/image/${reservationId}?signature=true`;
        let options = {};
        options.headers = {};
        options.headers['Content-Type'] = 'multipart/form-data boundary=---BOUNDARY';
        return this.authenticatedApi
            .multipart(uploadPhotoUrl, imageUpload.bodyForUpload, options)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicePhoto(response.image));
    }
    listServicePhotos(reservationId) {
        return this.authenticatedApi
            .get(`/adminservice/list_reservation_images/${reservationId}`)
            .toPromise()
            .then((response) => {
            return AgentBuilder.buildAgentServicePhotosList(response);
        });
    }
    updateServiceSignature(reservationId, imageUpload) {
        return this.authenticatedApi
            .multipart(`/adminservice/sign/${reservationId}`, imageUpload.bodyForUpload)
            .toPromise()
            .then((response) => response);
    }
    markPremiumServiceAsClientRequested(reservationId, duration) {
        const payload = {
            prediction: {
                duration: duration
            }
        };
        return this.authenticatedApi
            .put(`/adminservice/premium/${reservationId}`, JSON.stringify(payload))
            .toPromise().then(response => {
            if (response.reservation) {
                return ReservationBuilder.buildPremiumStatus(response.reservation.status);
            }
            else {
                return response;
            }
        });
    }
    assignService(reservationId, force = false) {
        const payload = {
            force
        };
        return this.authenticatedApi
            .post(`/adminservice/assignpremium/${reservationId}`, JSON.stringify(payload))
            .toPromise()
            .then((response) => response);
    }
    requestService(reservationId, agentId) {
        const payload = {
            agent_id: agentId
        };
        return this.authenticatedApi
            .post(`/adminservice/requestpremium/${reservationId}`, JSON.stringify(payload))
            .toPromise()
            .then((response) => response);
    }
    agentCarPicked(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/premium_car_picked/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    agentArrive(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/premium_agent_arrive/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    agentCarInBase(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/premium_checkin_car_in_base/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    queueService(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/queuepremium/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    unassignService(serviceUnassignation, reservationId) {
        const payload = AgentBuilder.buildServiceUnassignationPayload(serviceUnassignation);
        return this.authenticatedApi
            .post(`/adminservice/unassignpremium/${reservationId}`, JSON.stringify(payload))
            .toPromise()
            .then((response) => response);
    }
    getUser(reservationId) {
        return this.authenticatedApi
            .get(`/adminservice/user/${reservationId}`)
            .toPromise()
            .then((response) => UserBuilder.buildUser(response.user));
    }
    getUserPoints(reservationId) {
        return this.authenticatedApi
            .get(`/adminservice/userpoints/${reservationId}`)
            .toPromise()
            .then(response => {
            let pointsObject = response.points;
            return pointsObject ? pointsObject.currentpoints : null;
        });
    }
    updateUser(reservationId, user) {
        let payload = {
            default_invoice_profile: user.defaultInvoiceProfileId
        };
        return this.authenticatedApi
            .put(`/adminservice/user/${reservationId}`, JSON.stringify(payload))
            .toPromise()
            .then(response => UserBuilder.buildUser(response.user));
    }
    getService(reservationId, user_info = false) {
        const queryParams = { user_info };
        return this.authenticatedApi
            .get(`/adminservice/${reservationId}`, queryParams)
            .toPromise()
            .then((response) => ReservationBuilder.buildReservation(response.reservation, response.user || response.agency));
    }
    getPromotions(reservationID) {
        return reservationID ?
            this.authenticatedApi
                .get(`/adminservice/promotions/${reservationID}`)
                .toPromise()
                .then((response) => {
                return response.promotions.map(data => ProductBuilder.buildPromo(data));
            }) :
            this.authenticatedApi
                .get(`/adminservice/promotions`)
                .toPromise()
                .then((response) => {
                return response.promotions.map(data => ProductBuilder.buildPromo(data));
            });
    }
    checkInStarted(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/start_premium_checkin/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    pickupCanceled(reservationID) {
        return this.authenticatedApi
            .post(`/adminservice/cancel_premium_pickup/${reservationID}`)
            .toPromise()
            .then((response) => response);
    }
    checkInPickedCar(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/premium_checkin_transaction_completed/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    checkInParkedCar(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/close_premium_checkin/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    checkOutStarted(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/start_premium_checkout/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    checkOutClose(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/close_premium_checkout/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    charge(reservationId) {
        return this.authenticatedApi
            .post(`/adminservice/charge_reservation/${reservationId}`)
            .toPromise()
            .then((response) => response);
    }
    chargeNewCard(reservation_id, agent_id, card, save_card = false) {
        let accessToken = this.auth.getAccessToken();
        let isPciApiCall = true;
        if (!accessToken) {
            return Promise.reject(new AccessTokenMissingException());
        }
        let query = {
            reservation_id,
            authorization_token: accessToken,
            cardnumber: card.cardNumber,
            expiration_month: card.expirationMonth,
            expiration_year: card.expirationYear,
            cvv: card.cvv,
            signature: "",
            save_card
        };
        if (agent_id) {
            query['agent_id'] = agent_id;
        }
        query.signature = this.creditCardsApiService.calculatePciApiSignature(query);
        let validQueryParams = _.filter(query, val => !_.isNil(val));
        let queryString = _.join(_.map(validQueryParams, (val, key) => `${key}=${String(val)}`), "&");
        let options = {};
        options.headers = { Authorization: CryptoES.SHA256(accessToken).toString() };
        return this.apiService
            .get("/remote_tpv_payment", query, options, isPciApiCall)
            .toPromise()
            .then(response => {
            let responseData = response.paymethod ? response.paymethod : response;
            return PaymentMethodBuilder.buildPaymentMethod(response.paymethod);
        })
            .catch((error) => Promise.reject(error));
    }
    createVehicle(reservationId, vehicle) {
        let payload = VehicleBuilder.buildVehiclePayload(vehicle);
        return this.authenticatedApi
            .post(`/adminservice/vehicle/${reservationId}`, JSON.stringify(payload))
            .toPromise()
            .then(response => VehicleBuilder.buildVehicle(response.vehicle));
    }
    updateVehicle(reservationId, vehicle) {
        let payload = VehicleBuilder.buildVehiclePayload(vehicle);
        return this.authenticatedApi
            .put(`/adminservice/vehicle/${reservationId}/${vehicle.id}`, JSON.stringify(payload))
            .toPromise()
            .then(response => VehicleBuilder.buildVehicle(response.vehicle));
    }
    deleteVehicle(reservationId, id) {
        return this.authenticatedApi
            .delete(`/adminservice/vehicle/${reservationId}/${id}`)
            .toPromise()
            .then(response => response);
    }
    listQueuedServices() {
        return this.authenticatedApi
            .get(`/agent/premiumqueuedservices`)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicesList(response));
    }
    listNextServices(lotId, page = 0, filter = null, type = "premium") {
        const payload = { type, filter, page };
        return this.authenticatedApi
            .get(`/adminservice/nextservices/${lotId}`, payload)
            .toPromise()
            .then((response) => AgentBuilder.buildAgentServicesList(response));
    }
    createProfessionalProfile(reservationId, profile) {
        let payload = ProfileBuilder.buildProfessionalProfilePayload(profile);
        return this.authenticatedApi
            .post(`/adminservice/profile/${reservationId}`, JSON.stringify(payload))
            .toPromise()
            .then(response => ProfileBuilder.buildProfile(response.profile));
    }
    updateProfessionalProfile(reservationId, profile) {
        let payload = ProfileBuilder.buildProfessionalProfilePayload(profile);
        return this.authenticatedApi
            .put(`/adminservice/profile/${reservationId}/${profile.id}`, JSON.stringify(payload))
            .toPromise()
            .then(response => AdminProfileBuilder.buildAdminProfile(response.profile));
    }
    deleteProfile(reservationId, id) {
        return this.authenticatedApi
            .delete(`/adminservice/profile/${reservationId}/${id}`)
            .toPromise()
            .then(response => response);
    }
    getShift() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get('/adminuser/shift').toPromise();
            return AdminShiftBuilder.buildAdminShift(response.shift);
        });
    }
}
AgentApiService.ɵfac = function AgentApiService_Factory(t) { return new (t || AgentApiService)(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.AuthenticatedApiService), i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i3.AuthenticationService), i0.ɵɵinject(i4.CreditCardsApiService)); };
AgentApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AgentApiService, factory: AgentApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AgentApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.ApiService }, { type: i2.AuthenticatedApiService }, { type: i1.ApiService }, { type: i3.AuthenticationService }, { type: i4.CreditCardsApiService }]; }, null); })();
//# sourceMappingURL=agent-api.service.js.map